import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  GetSubjectNetsuiteDetailsCancelToken
} from "../../../../services/RegistrationService";
import PermissionsGate from "../../../../utils/permissionGate";
import Button from "../../../../components/library/Button";

function PMCLinkedModulesFormTransferCredit(props) {
  const {
    creditModules,
    setBtnDissable,
    loading,
    opportunityIds,
    setCreditText,
    setAdminCreditModulesIds,
    adminCreditModulesIds,
    loadingNSData,
    setLoadingNsData,
    readOnly
  } = props;  
  const [netsuiteItemDetails, setNetsuiteItemDetails] = useState({});
  const [discounts, setDiscounts] = useState({});
  const [groupedModules, setGroupedModules] = useState({});
  const handleRemove = (id) => {
    setAdminCreditModulesIds(prev => prev.filter(item => Number(item) !== Number(id)));
  }
  useEffect(() => {
    const source = axios.CancelToken.source();
    setLoadingNsData(true);
    
    
    const timeout = setTimeout(() => {
      if (opportunityIds?.length && adminCreditModulesIds?.length) {        
        const record = {
          opportunityIds: opportunityIds.join(","),
          items: adminCreditModulesIds.join(",")
        };
        setBtnDissable("PosttoNetsuite");
        setLoadingNsData(true);
        GetSubjectNetsuiteDetailsCancelToken(record, source.token)
        .then((response) => {
          if (response?.status == 200) {
            setNetsuiteItemDetails(response?.data);
            const discounts = {};
            Object.keys(response.data).forEach((key) => {
              const item = response.data[key];
              if (item.itemType == "Discount") {
                discounts[item.opportunityId] = [...discounts[item.opportunityId] || [], item];
              }
            });
            setDiscounts(discounts);
          }
          setLoadingNsData(false);
          setBtnDissable("");
        })
        .catch((error) => {
          if (!axios.isCancel(error)) {
          console.error(error);
          setLoadingNsData(false);
          setBtnDissable("");
        }          
        });
      }else{
        setLoadingNsData(false);
        setBtnDissable("");
      }
    }, 3000);
    return () => {
      clearTimeout(timeout);
      source.cancel("Operation canceled due to dependency change.");
    };
  }, [opportunityIds, adminCreditModulesIds]);
  
  
  
  useEffect(() => {
    let groupedModulesTemp = {};
    creditModules.forEach((module) => {
      const oppId = netsuiteItemDetails[module?.netsuite_product_id]?.opportunityId || "Unknown";
      if (!groupedModulesTemp[oppId]) groupedModulesTemp[oppId] = [];
      if(adminCreditModulesIds.includes(String(module?.netsuite_product_id))){
        groupedModulesTemp[oppId].push(module);
      }
    });
    
    Object.keys(groupedModulesTemp).forEach((key) => {
      groupedModulesTemp[key].sort((a, b) => (a.Code || "").localeCompare(b.Code || ""));
    });
    setGroupedModules(groupedModulesTemp);
  }, [creditModules, adminCreditModulesIds, netsuiteItemDetails])
  
  
  // Define the helper function outside your component or inside before the return
  const renderDiscountRows = (modules, discountItems, netsuiteItemDetails, loadingNSData, loading) => {
    // Sum module amounts for the current opportunity
    const moduleTotal = modules.reduce((acc, module) => {
      const amt = parseFloat(netsuiteItemDetails[module.netsuite_product_id]?.amount) || 0;
      return acc + amt;
    }, 0);
    
    return discountItems.map((discountItem, i) => {
      const discountRate = Math.abs(parseFloat(discountItem.rate) || 0);
      const calculatedDiscount = (moduleTotal * discountRate) / 100;
      
      return (
        <tr className="credit-list-row schedule-list-first schedule-list-rest discount" key={`${discountItem.description}-${i}`}>
        <td>{loadingNSData ? <i className="fa fa-cog fa-spin"></i> : "-"}</td>
        <td>{loadingNSData ? <i className="fa fa-cog fa-spin"></i> : discountItem.item || "-"}</td>
        <td>{loadingNSData ? <i className="fa fa-cog fa-spin"></i> : discountItem.quantity || "-"}</td>
        <td>{loadingNSData ? <i className="fa fa-cog fa-spin"></i> : discountItem.description || "-"}</td>
        <td>{loadingNSData ? <i className="fa fa-cog fa-spin"></i> : discountItem.priceLevel || "-"}</td>
        <td>{loadingNSData ? <i className="fa fa-cog fa-spin"></i> : Math.abs(parseFloat(discountItem.rate || 0)).toFixed(1) || "0"}%</td>
        {/* Discount Amount */}
        <td>{loadingNSData ? <i className="fa fa-cog fa-spin"></i> : Math.abs(calculatedDiscount || 0.0).toFixed(2)}</td>
        <td>{loadingNSData ? <i className="fa fa-cog fa-spin"></i> : discountItem.taxcode || "-"}</td>
        <td>{loadingNSData ? <i className="fa fa-cog fa-spin"></i> : parseFloat(discountItem.taxRate).toFixed(1) || "0"}%</td>
        {/* Tax Amount for discount row */}
        <td>
        {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : parseFloat(discountItem.taxRate).toFixed(2)}
        </td>
        {/* Gross Amount, same as discount amount if no further calc */}
        <td>{loadingNSData ? <i className="fa fa-cog fa-spin"></i> : Math.abs(calculatedDiscount || 0.0).toFixed(2)}</td>
        <td>{loading ? <i className="fa fa-cog fa-spin"></i> : discountItem.item ? discountItem.item.split(' ')?.[0] : "-"}</td>
        {/* <td>{loadingNSData ? <i className="fa fa-cog fa-spin"></i> : `${discountRate}%`}</td> */}
        <td>
        {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : 
          discountItem.opportunityLink ? 
          <a href={discountItem.opportunityLink} target="_blank">{discountItem.opportunityId || "-"}</a> : 
          "-"
        }
        </td>
        <td>
        {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : 
          discountItem.quoteLink ? 
          <a href={discountItem.quoteLink} target="_blank">{discountItem.quoteId || "-"}</a> : 
          "-"
        }
        </td>
        <td>-</td>
        </tr>
      );
    });
  };
  
  useEffect(() => {
    
    const header = "Credit Allocation\nItem, Price Level, Rate, Amount";
    // const header = "Credit Allocation\nItem, Price Level, Rate, Amount, Tax Code, Tax Rate, Tax Amt, Gross Amt, Item Code, Opportunity";
    const lines = [header];
    
    Object.entries(groupedModules || []).forEach(([oppId, modules]) => {
      // Process normal module rows
      modules.forEach((module) => {
        const itemDetail = netsuiteItemDetails[module?.netsuite_product_id] || {};
        const item = itemDetail.item || "-";
        const priceLevel = itemDetail.priceLevel || "-";
        const rate = (-Math.abs(parseFloat(itemDetail.rate || 0))).toFixed(2);
        const amount = (-Math.abs(parseFloat(itemDetail.amount || 0))).toFixed(2);
        const grossamount = (-Math.abs(parseFloat(itemDetail.grossAmount || 0))).toFixed(2);
        const itemCode = module?.Code || "-";
        lines.push(`${item}, ${priceLevel}, ${rate}, ${amount}`);
        // lines.push(`${item}, ${netsuiteItemDetails[module?.netsuite_product_id]?.quantity || "-"}, ${netsuiteItemDetails[module?.netsuite_product_id]?.description ? netsuiteItemDetails[module?.netsuite_product_id]?.description.replace(/\n/g, '') : "-"}, ${priceLevel}, ${rate}, ${amount}, ${netsuiteItemDetails[module?.netsuite_product_id]?.taxcode || "-"}, ${parseFloat(netsuiteItemDetails[module?.netsuite_product_id]?.taxRate || 0).toFixed(1) || "0.0"}%, ${parseFloat(netsuiteItemDetails[module?.netsuite_product_id]?.taxAmount || 0).toFixed(2)}, ${grossamount}, ${itemCode}, ${netsuiteItemDetails[module?.netsuite_product_id]?.opportunityId || "-"}`);
      });
      
      // Process discount rows for this opportunity – same calculations as in renderDiscountRows
      if (discounts[oppId] && discounts[oppId].length > 0) {
        // Sum module amounts for the current opportunity as done in the table
        const moduleTotal = modules.reduce((acc, module) => {
          const amt = parseFloat(netsuiteItemDetails[module?.netsuite_product_id]?.amount) || 0;
          return acc + amt;
        }, 0);
        const moduleGrossTotal = modules.reduce((acc, module) => {
          const amt = parseFloat(netsuiteItemDetails[module?.netsuite_product_id]?.grossAmount) || 0;
          return acc + amt;
        }, 0);
        
        discounts[oppId] && discounts[oppId].forEach((discountItem) => {
          const discountRate = Math.abs(parseFloat(discountItem.rate || 0));
          const calculatedDiscount = (moduleTotal * discountRate) / 100;
          const calculatedGrossDiscount = (moduleGrossTotal * discountRate) / 100;
          // For discount rows, use discount's fields for the text version
          const item = discountItem.item || "-";
          const priceLevel = discountItem.priceLevel || "-";
          const rate = Math.abs(parseFloat(discountItem.rate || 0)).toFixed(1);
          const amount = Math.abs(calculatedDiscount).toFixed(2);
          // const grossamount = Math.abs(calculatedGrossDiscount).toFixed(2);
          // // Item Code using first word of discount item (per table)
          // const itemCode = discountItem.item ? discountItem.item.split(" ")?.[0] : "-";
          // lines.push(`${item}, ${discountItem.quantity || "-"}, ${discountItem.description || "-"}, ${priceLevel}, ${rate}%, ${amount}, ${discountItem.taxcode || "-"}, ${parseFloat(discountItem.taxRate || 0).toFixed(1) || "0"}%, ${parseFloat(discountItem.taxAmount || 0).toFixed(2)}, ${grossamount}, ${itemCode}, ${discountItem.opportunityId || "-"}`);
          lines.push(`${item}, ${priceLevel}, ${rate}%, ${amount}`);
        });
      }
    });
    setCreditText(lines.join("\n"));
  }, [groupedModules, discounts]);
  
  return (
    <div>      
    {creditModules.length > 0 && (
      <>
      <hr/>
      <br/>
      <h5 className="heading-5">
      Account Credit Allocation {loading && <i className="fa fa-cog fa-spin"></i> }
      </h5>
      <br/>
      
      <table className="table Class-Shedule-main-table table table-bordered">
      <thead className="thead-dark">
      <tr className="thead-dark">      
      <th>Module</th>        
      <th>Item</th>
      <th>Quantity</th>
      <th>Description</th>
      <th>Price Level</th>
      <th>Rate</th>
      <th>Amount</th>
      <th>Tax Code</th>
      <th>Tax Rate</th>
      <th>Tax Amt</th>
      <th>Gross Amt</th>
      <th>Item Code</th>
      {/* <th>Discount Applied</th> */}
      <th>Opportunity</th>
      <th>Quote</th>
      <th>Action</th>
      </tr>
      </thead>
      <tbody>
      {Object.entries(groupedModules).map(([oppId, modules]) =>
        { return (<React.Fragment key={oppId}>
          {modules.map((module) => (
            <tr  className={`credit-list-row schedule-list-first schedule-list-rest ${module?.optional == 0 ? "disabled" : ''}`} key={module?.module_id}>
            <td>
            {loading ? <i className="fa fa-cog fa-spin"></i> : module?.name}
            </td>
            <td>
            {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : netsuiteItemDetails[module?.netsuite_product_id]?.item || "-"}
            </td>  
            <td>
            {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : netsuiteItemDetails[module?.netsuite_product_id]?.quantity || "-"}
            </td>
            <td>
            {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : netsuiteItemDetails[module?.netsuite_product_id]?.description ? netsuiteItemDetails[module?.netsuite_product_id]?.description.replace(/<[^>]+>/g, '') : "-"}
            </td>
            <td>
            {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : netsuiteItemDetails[module?.netsuite_product_id]?.priceLevel || "-"}
            </td>
            <td>
            {loadingNSData ? (<i className="fa fa-cog fa-spin"></i>) : ((-Math.abs(parseFloat(netsuiteItemDetails[module?.netsuite_product_id]?.rate || 0.0))).toFixed(2) || "-")}
            </td> 
            <td>
            {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : ((-Math.abs(parseFloat(netsuiteItemDetails[module?.netsuite_product_id]?.amount || 0.0))).toFixed(2) || "-")}
            </td>
            <td>
            {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : netsuiteItemDetails[module?.netsuite_product_id]?.taxcode || "-"}
            </td>
            <td>
            {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : parseFloat(netsuiteItemDetails[module?.netsuite_product_id]?.taxRate || 0.0).toFixed(1) || "-"}%
            </td>
            <td>
            {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : parseFloat(netsuiteItemDetails[module?.netsuite_product_id]?.taxAmount || 0).toFixed(2) || "0"}
            </td>
            <td>
            {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : ((-Math.abs(parseFloat(netsuiteItemDetails[module?.netsuite_product_id]?.grossAmount || 0.0))).toFixed(2) || "-")}
            </td>
            <td>
            {loading ? <i className="fa fa-cog fa-spin"></i> : module?.Code || "-"}
            </td>
            {/* <td>
              {loadingNSData ? <i className="fa fa-cog fa-spin"></i> : netsuiteItemDetails[module?.netsuite_product_id]?.discount || "0"}%
              </td> */}
              <td>
              {loadingNSData ? 
                <i className="fa fa-cog fa-spin"></i> : 
                netsuiteItemDetails[module?.netsuite_product_id]?.opportunityLink ? 
                <a href={netsuiteItemDetails[module?.netsuite_product_id]?.opportunityLink} target="_blank">{netsuiteItemDetails[module?.netsuite_product_id]?.opportunityId || "-"}</a> : 
                "-"
              }
              </td>
              <td>
              {loadingNSData ? 
                <i className="fa fa-cog fa-spin"></i> : 
                netsuiteItemDetails[module?.netsuite_product_id]?.quoteLink ? 
                <a href={netsuiteItemDetails[module?.netsuite_product_id]?.quoteLink} target="_blank">{netsuiteItemDetails[module?.netsuite_product_id]?.quoteId || "-"}</a> : 
                "-"
              }
              </td>
              <td>
              {loading ? <i className="fa fa-cog fa-spin"></i> : 
                (module?.optional == 1) ? (<>
                  <div className="col-sm-1">
                  <PermissionsGate scopes={['RegPMCSelectionEdit']} errorProps={{ disabled: true }}>
                    <Button
                      variant="destructive"
                      size="sm"
                      type="button"
                      title="Delete"
                      onClick={() => handleRemove(module?.netsuite_product_id)}
                      disabled={readOnly}
                      className="rounded-circle"
                      style={{ width: '32px', height: '32px', padding: 0, borderRadius: '50%' }}
                    >
                      <i className="fal fa-trash-alt"></i>
                    </Button>
                  </PermissionsGate>
                  </div>
                  </>): '-'
                }
                </td>
                </tr>
              ))}
              {discounts[oppId] && discounts[oppId].length > 0 &&
                renderDiscountRows(modules, discounts[oppId], netsuiteItemDetails, loadingNSData, loading)
              }
              </React.Fragment>
            )})}
            </tbody>
            </table>
            </>
          )}
          </div>
        );
        
      }
      
      export default PMCLinkedModulesFormTransferCredit;
      